import { RouterModule, Routes } from "@angular/router";
import { AILibraryComponent } from './ai-library/ai-library.component';
import { AILibraryDetailsComponent } from './ai-library/e-library-details/ai-library-details.component';

import { path } from 'app/app.config';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewAiLibraryComponent } from "./ai-library/new-ai-library/new-ai-library.component";

const routes: Routes = [
  {path: 'policylibrary', redirectTo: 'policylibrary/ai-library', pathMatch: 'full'},
  {
    path: 'policylibrary/ai-library', component: AILibraryComponent, children:[
      { path: 'newclass', component: NewAiLibraryComponent },
      {path: ':id', component:  AILibraryDetailsComponent}
      ]
    }
]

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  declarations: [],
  exports: [RouterModule]
})

export class AIlibraryRoutingModule { }
